import { render, staticRenderFns } from "./MiniTotalsTableFiveCol.vue?vue&type=template&id=bf7e62d2&"
import script from "./MiniTotalsTableFiveCol.vue?vue&type=script&lang=js&"
export * from "./MiniTotalsTableFiveCol.vue?vue&type=script&lang=js&"
import style0 from "./MiniTotalsTableFiveCol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VSimpleTable})
